export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  
  STUDENT: {
    HOME: '/student',
    DASHBOARD: '/student',
    PROFILE: '/student/profile',
    LOG_HOURS: '/student/hours',
    APPLICATIONS: {
      LIST: '/student/applications',
      DETAIL: (id: string | number) => `/student/applications/${id}`,
      NEW: (opportunityId: string | number) => `/student/applications/new/${opportunityId}`
    },
    OPPORTUNITIES: {
      LIST: '/student/opportunities',
      DETAIL: (id: string | number) => `/student/opportunities/${id}`,
    },
    HOURS: {
      LIST: '/student/hours',
      LOG: '/student/hours/log',
    }
  },

  TEACHER: {
    HOME: '/teacher',
    DASHBOARD: '/teacher',
    STUDENTS: '/teacher/students',
    APPROVALS: '/teacher/approvals',
    CLASS: '/teacher/class'
  },

  ORGANIZATION: {
    HOME: '/organization',
    DASHBOARD: '/organization/dashboard',
    PROFILE: '/organization/profile',
    OPPORTUNITIES: {
      LIST: '/organization/opportunities',
      CREATE: '/organization/opportunities/create',
      DETAIL: (id: string | number) => `/organization/opportunities/${id}`,
      EDIT: (id: string | number) => `/organization/opportunities/${id}/edit`,
    },
    APPLICATIONS: '/organization/applications'
  }
} as const;

// Type for route parameters
export type RouteParams = {
  id?: string;
};

// Helper function to generate path with parameters
export const generatePath = (path: string, params?: RouteParams): string => {
  if (!params) return path;
  return Object.entries(params).reduce(
    (acc, [key, value]) => acc.replace(`:${key}`, value),
    path
  );
};
